import { formatDoseSessionColumn } from './reportTableColumns';
import { formatSignificantFigures, formatSignificantFiguresOrDash } from './formatSignificantFigures.js';

/**
 * @param {object|null|undefined} params — CalculationRecord.params для mode mixed / AdaptiveRT
 * @returns {boolean}
 */
export function isAdaptiveRtHistoryParams(params) {
  return !!(params && Array.isArray(params.stages) && params.stages.length > 0);
}

/**
 * @param {object|null|undefined} params
 * @returns {string}
 */
export function formatAdaptiveRtDoseColumn(params) {
  if (!isAdaptiveRtHistoryParams(params)) return '';
  return params.stages
    .map((stage, index) => {
      const frac = stage?.fractionation || {};
      const col = formatDoseSessionColumn(frac);
      return col && col !== '—' ? `Эт.${index + 1}: ${col}` : null;
    })
    .filter(Boolean)
    .join('; ') || '—';
}

/**
 * @param {object|null|undefined} result — CalculationRecord.result
 * @returns {string}
 */
export function formatAdaptiveRtTcpResult(result) {
  if (!result || typeof result !== 'object') return '';
  const tcp = result.result;
  if (tcp == null) return '';
  const eqd2 = result.eqd2_sum ?? result.eqd2;
  const eud = result.eud_sum ?? result.eud;
  const eqPart = eqd2 != null ? `, EQD2Σ=${formatSignificantFiguresOrDash(eqd2)}` : '';
  const eudPart = eud != null ? `, EUDΣ=${formatSignificantFiguresOrDash(eud)}` : '';
  return `TCP ${formatSignificantFigures(tcp)}%${eqPart}${eudPart}`;
}

/**
 * @param {Array<{ model_type?: string, params?: object, result?: object, model_name?: string, structure_name?: string }>} items
 * @returns {string}
 */
export function formatAdaptiveRtNtcpResult(result) {
  if (!result || typeof result !== 'object') return '';
  const ntcp = result.result;
  if (ntcp == null) return '';
  const eqd2 = result.eqd2_sum ?? result.eqd2;
  const eud = result.eud_sum ?? result.eud;
  const eqPart = eqd2 != null ? `, EQD2Σ=${formatSignificantFiguresOrDash(eqd2)}` : '';
  const eudPart = eud != null ? `, EUDΣ=${formatSignificantFiguresOrDash(eud)}` : '';
  return `NTCP ${formatSignificantFigures(ntcp)}%${eqPart}${eudPart}`;
}

export function adaptiveRtNtcpSummaryFromItems(items) {
  if (!items?.length) return '—';
  const ntcp = items.find((i) => i.model_type === 'NTCP');
  if (!ntcp) return '—';
  const struct = ntcp.structure_name || ntcp.params?.structure_name || '—';
  const resultLine = formatAdaptiveRtNtcpResult(ntcp.result);
  if (resultLine) {
    return `${ntcp.model_name || 'Niemierko'} / ${struct} — ${resultLine}`;
  }
  return `${ntcp.model_name || '—'} / ${struct}`;
}

export function adaptiveRtTcpSummaryFromItems(items) {
  if (!items?.length) return '—';
  const tcp = items.find((i) => i.model_type === 'TCP');
  if (!tcp) return '—';
  const struct = tcp.structure_name || tcp.params?.structure_name || '—';
  const resultLine = formatAdaptiveRtTcpResult(tcp.result);
  if (resultLine) {
    return `${tcp.model_name || 'Niemierko'} / ${struct} — ${resultLine}`;
  }
  return `${tcp.model_name || '—'} / ${struct}`;
}
